import { ReactNode } from "react";
import { Navigate, useParams } from "react-router-dom";
import { Loader } from "@themes/pollinator/ui/Loader";
import { useProgram } from "@platform/hooks/useProgram";
import { useIsEnrollmentClosed } from "@platform/hooks/useIsEnrollmentClosed";
import { PROGRAM_ROLE_SLUG } from "@core/features/program";

export type Props = {
  children: ReactNode;
};

/**
 * Blocks routes for enrolled participants who did not complete onboarding
 * while enrollment is closed. Redirects to /dashboard/:id, where
 * ParticipantNotOnboardedMessage explains the situation.
 */
export function EnrollmentClosedGate({ children }: Props) {
  const { id } = useParams<{ id: string }>();
  const { program, isLoading } = useProgram();
  const isEnrollmentClosed = useIsEnrollmentClosed();

  if (isLoading) {
    return <Loader isFullPage />;
  }

  const userRoles = program?.user_roles;
  const isOnboarded = userRoles?.includes(
    PROGRAM_ROLE_SLUG.ONBOARDED_PARTICIPANT
  );
  const isWithdrawn = userRoles?.includes(PROGRAM_ROLE_SLUG.WITHDRAWN_USER);

  if (isWithdrawn || (isEnrollmentClosed && !isOnboarded)) {
    return <Navigate to={`/dashboard/${id}`} replace />;
  }

  return <>{children}</>;
}

export default EnrollmentClosedGate;
